import React, { useState } from 'react';

const TotpLoginStep = ({ userId, onSuccess, onBack }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch('/api/auth/totp/verify-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, code }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Verification failed');
      onSuccess(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      minHeight: '100vh', backgroundColor: '#050508', padding: '20px',
    }}>
      <div style={{
        width: '100%', maxWidth: '380px', background: 'rgba(17,17,25,0.75)',
        backdropFilter: 'blur(16px)', border: '1px solid #222230',
        borderRadius: '10px', padding: '36px', boxShadow: '0 24px 64px rgba(0,0,0,0.9)',
      }}>
        <h2 style={{ margin: '0 0 8px 0', color: '#fff', fontSize: '20px', fontWeight: '700' }}>
          Authenticator Code
        </h2>
        <p style={{ margin: '0 0 24px 0', color: '#8a8a9e', fontSize: '13px' }}>
          Enter the 6-digit code from your Google Authenticator app.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            placeholder="000000"
            maxLength={6}
            autoFocus
            style={{
              width: '100%', padding: '14px', background: 'rgba(5,5,8,0.6)',
              border: '1px solid #222230', borderRadius: '6px', color: '#fff',
              fontSize: '24px', letterSpacing: '0.3em', textAlign: 'center',
              outline: 'none', boxSizing: 'border-box', marginBottom: '16px',
            }}
            onFocus={(e) => e.target.style.borderColor = '#a336ff'}
            onBlur={(e) => e.target.style.borderColor = '#222230'}
          />
          {error && <p style={{ color: '#ff4466', fontSize: '13px', marginBottom: '12px' }}>{error}</p>}
          <button type="submit" disabled={loading || code.length !== 6} style={{
            width: '100%', padding: '12px', background: 'linear-gradient(135deg, #a336ff 0%, #791fd9 100%)',
            border: '1px solid #cc88ff', borderRadius: '6px', color: '#fff',
            fontWeight: '600', fontSize: '14px', cursor: 'pointer',
            opacity: code.length !== 6 ? 0.5 : 1,
          }}>
            {loading ? 'Verifying...' : 'Verify'}
          </button>
        </form>
        <button onClick={onBack} style={{
          marginTop: '16px', background: 'none', border: 'none',
          color: '#525266', fontSize: '13px', cursor: 'pointer', padding: 0,
        }}>
          ← Back to login
        </button>
      </div>
    </div>
  );
};

export default TotpLoginStep;
